import React from 'react';
import {
  //Button,
  //Col,
  //Container,
  Alert,
  //FormControl,
  //Nav,
  //Navbar,
  //NavDropdown,
  //Row,
  //Form,
  Badge
  //InputGroup,
  //FloatingLabel,
  //Div
} from 'react-bootstrap';
import PMono from './p/PMono'
import PText from './p/PText'
//import PTextLabel from './p/PTextLabel'
import utils from '../utils'

export default class EcuMessageGen extends React.Component {
  //constructor(props) {    
  //  super(props)    
  //}  
  render() {
    if (this.props.data === undefined) 
      return ""

    var hex_bytes = utils.byteArrayToHex(this.props.data._b)
    var ko_visible = (!this.props.data.res) ? "visually-hidden" : ""
    
    if (this.props.data.text !== undefined) {
      return (
        <>          
          <Alert variant="info">
            <Alert.Heading>{this.props.title} <Badge bg="danger" className={ko_visible}>KO</Badge></Alert.Heading>
            <PMono value={hex_bytes} />
            <hr />
            <PText value={this.props.data.text} />
          </Alert>
        </>
      )
    }
    return (
      <>          
        <Alert variant="info">
          <Alert.Heading>{this.props.title} <Badge bg="danger" className={ko_visible}>KO</Badge></Alert.Heading>
          <PMono value={hex_bytes} />
        </Alert>
      </>
    )
  }
}